import { c as _c } from "react/compiler-runtime";
import { mergeClasses } from '@/utils/style';
import React, { PropsWithChildren } from 'react';
import Link from 'next/link';
import IconArrowRight from '@/assets/icons/heroIcons/Chevron-right.svg';
import { addPrefixToDataParams } from '@/utils/string';
import { ActionProps } from '@/types/actionProps';
import { LinkProps } from '@/components/links';
export type FilledButtonProps = PropsWithChildren<ActionProps & {
  icon?: React.JSX.Element;
}>;
export function FilledButton(t0) {
  const $ = _c(21);
  const {
    analyticsParam,
    children,
    className,
    icon,
    testId,
    title,
    to,
    variant: t1,
    onClick,
    target,
    arrowIcon
  } = t0;
  const variant = t1 === undefined ? "lg" : t1;
  const t2 = variant === "lg" && "shadow-outer-sm hover:text-white hover:bg-blue-500 py-3 pl-3 pr-4 lg:py-4 lg:pl-4 lg:pr-5 rounded-lg lg:rounded-2xl";
  const t3 = variant === "sm" && "hover:bg-blue-100 p-2 rounded-md";
  const t4 = variant === "xs" && "py-0 p0";
  let t5;
  if ($[0] !== className || $[1] !== t2 || $[2] !== t3 || $[3] !== t4) {
    t5 = mergeClasses("text-left group flex flex-row gap-3 items-center justify-between w-70 lg:w-94 font-semibold text-sm lg:text-base bg-white text-blue-500 transition", t2, t3, t4, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const fullClassName = t5;
  let t6;
  if ($[5] !== analyticsParam || $[6] !== testId) {
    t6 = addPrefixToDataParams({
      analyticsParam,
      testId,
      prefix: "btn"
    });
    $[5] = analyticsParam;
    $[6] = testId;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const dataParams = t6;
  let t7;
  if ($[8] !== arrowIcon || $[9] !== children || $[10] !== icon || $[11] !== variant) {
    t7 = function renderContent() {
      return <><span className="shrink-0">{icon}</span><span className={mergeClasses("flex-1 overflow-hidden break-words text-gray-900", {
          "group-hover:text-white": variant === "lg"
        })}>{children}</span><span className="flex shrink-0">{arrowIcon || <IconArrowRight className="h-6 w-6" />}</span></>;
    };
    $[8] = arrowIcon;
    $[9] = children;
    $[10] = icon;
    $[11] = variant;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const renderContent = t7;
  let t8;
  if ($[13] !== dataParams || $[14] !== fullClassName || $[15] !== onClick || $[16] !== renderContent || $[17] !== target || $[18] !== title || $[19] !== to) {
    t8 = to ? <Link {...dataParams} target={target} href={to} onClick={onClick} title={title} className={fullClassName}>{renderContent()}</Link> : <button onClick={onClick} {...dataParams} title={title} className={fullClassName}>{renderContent()}</button>;
    $[13] = dataParams;
    $[14] = fullClassName;
    $[15] = onClick;
    $[16] = renderContent;
    $[17] = target;
    $[18] = title;
    $[19] = to;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}